import type { PickListMap } from 'state/selectedProject/selectedProjectHooks';
import { getDisplayName } from 'utils/names';
import { getTextWidth } from 'utils/strings/getTextWidth';

import { createStringWidthCalculator } from './domCalculation';

/**
 * Calculate string width with cache.
 * */
export const getStringWidth = createStringWidthCalculator(getTextWidth);

export const getLongestPicklistValueWidth = (pickListMap: PickListMap, minLength: number) => {
  const maxLength = getMaxPickValueWidth(pickListMap, getStringWidth);
  return Math.max(minLength, maxLength);
};

export const getMaxPickValueWidth = (pickListMap: PickListMap, getWidth: (text: string) => number) => {
  return Object.values(pickListMap).reduce<number>((maxWidth, displayNames) => {
    const displayValue = getDisplayName(displayNames);

    const widthForDisplayValue = getWidth(displayValue);

    return Math.max(widthForDisplayValue, maxWidth);
  }, 0);
};
